<template>
  <Detail :id="null" />
</template>

<script>
// @ is an alias to /src
import Detail from "@/components/template-categories/Detail";

export default {
  name: "TemplateCategoryCreate",
  components: {
    Detail,
  },
};

</script>